import * as React from 'react';
import { TPage } from '../../types/helper';
import { InsidePage } from '../InsidePage';
import { MainPage } from '../MainPage';

export interface IHelperProps {
  page: TPage;
}

export class Helper extends React.Component<IHelperProps> {
  public render() {
    const { page } = this.props;

    switch (page) {
      case 'start':
      case 'ad':
      case 'show':
      case 'before-deal':
      case 'deal':
      case 'after-deal':
        return <InsidePage page={page} />;
      case 'main':
      default:
        return <MainPage />;
    }
  }
}
